<h1 mat-dialog-title>{{ 'Skill level' | translate }}</h1>
<div mat-dialog-content>

  <!-- Name -->
  <mat-form-field>
    <mat-label>{{ 'Name' | translate }}</mat-label>
    <input matInput [(ngModel)]="data.name">
  </mat-form-field>

  <div class="col">

    <!-- Is Tutor -->
    <mat-checkbox color="primary" [(ngModel)]="data.isTutor" (change)="onRoleUpdated()">{{ 'Is Tutor' | translate }}</mat-checkbox>

    <!-- Is Expert -->
    <mat-checkbox color="primary" [(ngModel)]="data.isExpert" [disabled]="data.isTutor">{{ 'Is Expert' | translate }}</mat-checkbox>

  </div>

</div>
<div mat-dialog-actions class="actions">
  <button mat-stroked-button (click)="onNoClick()">{{ 'Cancel' | translate }}</button>
  <div>
    <button mat-flat-button color="primary" [mat-dialog-close]="data" [disabled]="!validate()" cdkFocusInitial>{{ 'Save' | translate }}</button>
  </div>
</div>
